import React, { useState } from 'react';
import './Login.css';
import logo from '../assets/LOGO SIN FRASE.png';

const Login = ({ onLoginSuccess }) => {
  const [usuario, setUsuario] = useState('');
  const [password, setPassword] = useState('');
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');

  // Usuarios del sistema con sus roles
  const usuarios = {
    'gerente': { password: 'paty2026', rol: 'gerente', nombre: 'Gerente' },
    'empleado': { password: 'md2026', rol: 'empleado', nombre: 'Empleado' },
    'logistica': { password: 'Lmd2026', rol: 'logistica', nombre: 'Logística' },
    'mostrador': { password: 'Mmd2026', rol: 'mostrador', nombre: 'Mostrador' },
    'cajas': { password: 'Cmd2026', rol: 'cajas', nombre: 'Cajas' }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setCargando(true);
    setError('');

    try {
      // Simular delay de autenticación
      await new Promise(resolve => setTimeout(resolve, 1000));

      const usuarioData = usuarios[usuario.toLowerCase()];
      
      if (usuarioData && usuarioData.password === password) {
        // Guardar datos del usuario en localStorage
        localStorage.setItem('usuario', JSON.stringify({
          usuario: usuario,
          rol: usuarioData.rol,
          nombre: usuarioData.nombre
        }));
        
        onLoginSuccess(usuarioData.rol, usuarioData.nombre);
      } else {
        setError('Usuario o contraseña incorrectos. Intenta nuevamente.');
      }
    } catch (error) {
      console.error('Error al iniciar sesión:', error);
      setError('Error al iniciar sesión. Intenta nuevamente.');
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="logo-container">
          <img src={logo} alt="MADERERÍA LA HUERTA" className="logo-image" />
        </div>
      </div>
      <div className="login-right">
        <div className="login-form-container">
          <h1 className="logistica-title">LOGISTICA</h1>
          <form className="login-form" onSubmit={handleLogin}>
            <div className="form-group">
              <label htmlFor="usuario">Usuario</label>
              <input
                type="text"
                id="usuario"
                value={usuario}
                onChange={(e) => setUsuario(e.target.value)}
                placeholder="Ingrese su usuario"
                required
                disabled={cargando}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Contraseña</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Ingrese su contraseña"
                required
                disabled={cargando}
              />
            </div>

            {error && (
              <div className="error-message">
                {error}
              </div>
            )}

            <button 
              type="submit" 
              className="btn-login"
              disabled={cargando}
            >
              {cargando ? 'Iniciando sesión...' : 'Iniciar Sesión'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;